module.exports = __webpack_public_path__ + "img/ryi.6d198ebf.png";